/**
 *  老虎机抽奖组件
 */

import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import SlotMachine, { SlotMachineAction } from "@/components/SlotMachine";
import styles from "./style.module.less";
import NameList from "../../../nameList";
import CountDown from "../../../countDown";
import { useServerNow } from "@/hooks/useServerTimeSync";
import { trackGdp } from "@/utils/gio-report";
import { getChannel } from "@/utils/tools";
import { Toast } from "@xp-design/mobile";
import { userPrizeDraw } from "@/api/configPage";
import useGetLoaclIp from "@/hooks/useGetLocalIP/useGetLoaclIp";
import { prizeDialogData } from "../../tool";
import LotteryBtn from "../../../lotteryBtn";
import { map } from "lodash-es";

interface MachineProps {
  pageInfo: any;
  activityInfo: any;
  activityStatusList: any;
  actInfo: any;
  btnUrl: string;
  afterDraw?: (prizeData: any) => void;
}

interface MachineRef {
  play: () => void;
}

const Machine = forwardRef<MachineRef, MachineProps>(
  (
    { pageInfo, activityInfo, activityStatusList, actInfo, afterDraw, btnUrl },
    ref,
  ) => {
    const serverNow = useServerNow();
    const slotMachineRef = useRef<SlotMachineAction>(null);
    const nameListRef = useRef<any>(null);
    const [downTime, setDownTime] = useState("");
    const { localIP } = useGetLoaclIp();
    const isPlaying = useRef(false); // 是否正在抽奖中
    const prize = useRef({});
    const [prizeMaskShow, setPrizeMaskShow] = useState(false);

    const slotPlay = async () => {
      if (isPlaying.current) {
        return;
      }
      trackGdp("P20189", "B004", {
        trackName: "充电_营销专题页_组件点击",
        origin: getChannel(),
        userType: "",
        versionId: activityInfo.versionCode,
        pageId: activityInfo.pageCode,
        ComponentCode: activityInfo.moduleId,
        type: activityInfo.moduleType,
        activityId: pageInfo.base[0].val.valCode,
        comp_style: JSON.parse(activityInfo.moduleJson).visual?.visualData[0]
          ?.typeName,
        status:
          activityStatusList[actInfo?.lotteryActivityDto?.activityStatus] || "",
        clickLocation: "抽奖按钮",
        remain_times: actInfo?.lotteryUserCountDto?.[0]?.remainingTimes,
      });
      if (actInfo?.lotteryUserCountDto?.[0]?.remainingTimes === 0) {
        Toast.show({
          content: "抽奖机会已用完，请做任务获得更多机会",
        });
        return;
      }
      isPlaying.current = true;
      setPrizeMaskShow(true);
      setContentOverflow(true);
      try {
        // Loading.show("加载中...");
        const res: any = await userPrizeDraw({
          activityCode: pageInfo.base[0].val.valCode,
          ip: localIP,
        });

        if (res.code === 200) {
          slotMachineRef.current?.play();
          const { productCode } = res.data;
          // 设置点击过的卡片
          const index = pageInfo?.prizes?.prizeData?.findIndex(
            (item) => item.productCode === productCode,
          );
          console.log(
            "%c Line:219 🍣 pageInfo?.prizes?.prizeData",
            "color:#ea7e5c",
            pageInfo?.prizes?.prizeData,
          );
          console.log("%c Line:219 🌭 index", "color:#6ec1c2", index);
          prize.current = await new Promise((resolve) => {
            setTimeout(() => {
              resolve(prizeDialogData(res.data, pageInfo));
              // 抽奖 默认旋转时间为5秒 5秒后再展示中将结果
            }, 3500);
          });
          if (!index && index != 0) {
            // 如果查询不到中奖的奖品索引 则证明没有中奖  老虎机要回到初始状态
            slotMachineRef.current?.stop(getRandomSortedArray(3));
          } else {
            slotMachineRef.current?.stop([index, index, index]);
          }
        } else {
          slotMachineRef.current?.stop(getRandomSortedArray(3));
          Toast.show({
            content: res.msg,
          });
          isPlaying.current = false;
          setPrizeMaskShow(false);
          setContentOverflow(false);
        }
      } catch (error: any) {
        console.log(error);
        // Loading.hide();
      } finally {
        // Loading.hide();
        setTimeout(() => {
          isPlaying.current = false;
          setPrizeMaskShow(false);
          setContentOverflow(false);
        }, 3000);
      }
    };

    useImperativeHandle(ref, () => ({
      play: slotPlay,
    }));

    useEffect(() => {
      setDownTime(
        actInfo?.lotteryActivityDto?.activityEndTime?.replace(/-/g, "/"),
      );
    }, [actInfo]);

    const nameListCom = (isNeedBack = true) => {
      return (
        !["3-3", "4"].includes(actInfo?.lotteryActivityDto?.activityStatus) &&
        pageInfo?.elementSwitch?.switchData[2]?.val === "1" && (
          <NameList
            isNeedBack={isNeedBack}
            activityCode={pageInfo?.base?.[0]?.val?.valCode}
            ref={nameListRef}
          />
        )
      );
    };

    const timeCountdown = (bgUrl) => {
      return (
        !["3-3", "4"].includes(actInfo?.lotteryActivityDto?.activityStatus) &&
        pageInfo?.elementSwitch?.switchData[1]?.val === "1" &&
        serverNow >
          new Date(
            actInfo?.lotteryActivityDto?.activityBeginTime?.replace(/-/g, "/"),
          ).getTime() && <CountDown bgUrl={bgUrl} endTime={downTime} />
      );
    };

    const prizesLen = useMemo(
      () => pageInfo?.prizes?.prizeData.length,
      [pageInfo],
    );

    const getRandomSortedArray = (n: number) => {
      // 创建一个从 0 到 n-1 的数组
      const arr = Array.from({ length: n }, (_, index) => index);

      // 使用 Fisher-Yates 洗牌算法随机打乱数组
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1)); // 随机生成一个索引
        [arr[i], arr[j]] = [arr[j], arr[i]]; // 交换两个元素
      }

      return arr;
    };

    const slotsArr = [
      getRandomSortedArray(prizesLen),
      getRandomSortedArray(prizesLen),
      getRandomSortedArray(prizesLen),
    ];

    const slotMachineConfig = useMemo(
      () => ({
        // 背景配置
        blocks: [
          {
            imgs: [
              {
                src: pageInfo?.visual?.prizeSetting?.[0]?.content?.[9]?.val,
              },
            ],
          },
        ],
        // 插槽配置(方向，排序，速度)
        slots: [
          {
            direction: 1,
            order: slotsArr[0],
            speed: 60,
          },
          {
            direction: -1,
            order: slotsArr[1],
            speed: 60,
          },
          {
            direction: 1,
            order: slotsArr[2],
            speed: 60,
          },
        ],
        // 奖品配置
        prizes: map(pageInfo?.prizes?.prizeData, (item) => ({
          imgs: [
            { src: item.val, width: "108rem", height: "108rem", top: "16rem" },
          ],
        })),
        // 插槽上方的文字
        topBar: {
          content: nameListCom(false),
        },
        // 插槽下方的文字
        bottomBar: {
          content:
            // pageInfo?.visual?.prizeSetting[0].content[7].val
            timeCountdown(
              pageInfo?.visual?.prizeSetting?.[0]?.content?.[7]?.val,
            ),
          style: {
            lineHeight: "14rem",
          },
        },
        onEnd() {
          setTimeout(() => {
            // Loading.hide();
            isPlaying.current = false;
            setPrizeMaskShow(false);
            setContentOverflow(false);
            afterDraw?.(prize.current);
            nameListRef?.current?.refresh(pageInfo?.base?.[0]?.val?.valCode); // 更新走马灯内容
          }, 500);
        },
      }),
      [pageInfo, downTime],
    );

    const setContentOverflow = (hidden: boolean) => {
      document.body.style.overflow = hidden ? "hidden" : "auto";
      document.body.style.pointerEvents = hidden ? "none" : "";
      const configPage = document.getElementById("configPage");
      if (configPage) {
        configPage.style.overflow = hidden ? "hidden" : "auto";
      }
    };

    return (
      <>
        <div className={styles.SlotMachine}>
          <SlotMachine ref={slotMachineRef} {...slotMachineConfig} />
          <LotteryBtn
            onOpenPlay={slotPlay}
            btnUrl={btnUrl}
            showCount={pageInfo?.elementSwitch?.switchData[0]?.val === "1"}
            count={actInfo?.lotteryUserCountDto?.[0]?.remainingTimes}
          />
        </div>
        {prizeMaskShow && <div className={styles.prizeMask}></div>}
      </>
    );
  },
);

export default Machine;
